// Story progress: the highest chapter index the player has unlocked.
// Prologue (0) is always available; finishing chapter N unlocks N+1.
import { CHAPTERS } from './JKGame_story'

const KEY = 'jkgame.story.unlocked'

export function getUnlocked(): number {
  try {
    // Floor + clamp on READ: a corrupted/tampered value (a float like "3.7", or an oversized
    // "999") must not falsely unlock every chapter or light the "all cleared" 🏆. The most
    // that's meaningful is CHAPTERS.length (finishing the last chapter unlocks one past it).
    const v = Math.floor(Number(localStorage.getItem(KEY)))
    if (!Number.isFinite(v) || v <= 0) return 0
    return Math.min(v, CHAPTERS.length)
  } catch {
    return 0
  }
}

export function unlockUpTo(index: number): void {
  if (index <= getUnlocked()) return
  try {
    localStorage.setItem(KEY, String(index))
  } catch {
    /* ignore */
  }
}
